import * as R from 'ramda';

import {createSelector} from 'reselect';
import {getItem, getKeyById} from 'redux/hor/module/selectors';

export const getRequestKey = createSelector(
  R.path(['routeParams', 'requestId']),
  R.path(["request"]),

  getKeyById
)

export const getRequestSelector = createSelector(
  getRequestKey,
  R.path(["request"]),

  getItem,
);